/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import * as tslib_1 from "tslib";
import { TemplatePortal } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component, ContentChild, Input, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation, } from '@angular/core';
import { mixinDisabled } from '@angular/material/core';
import { Subject } from 'rxjs/Subject';
import { MatTabLabel } from './tab-label';
/**
 * \@docs-private
 */
var MatTabBase = (function () {
    function MatTabBase() {
    }
    return MatTabBase;
}());
export { MatTabBase };
export var /** @type {?} */ _MatTabMixinBase = mixinDisabled(MatTabBase);
var MatTab = (function (_super) {
    tslib_1.__extends(MatTab, _super);
    /**
     * @param {?} _viewContainerRef
     */
    function MatTab(_viewContainerRef) {
        var _this = _super.call(this) || this;
        _this._viewContainerRef = _viewContainerRef;
        /**
         * The plain text label for the tab, used when there is no template label.
         */
        _this.textLabel = '';
        /**
         * The portal that will be the hosted content of the tab
         */
        _this._contentPortal = null;
        /**
         * Emits whenever the label changes.
         */
        _this._labelChange = new Subject();
        /**
         * Emits whenevfer the disable changes
         */
        _this._disableChange = new Subject();
        /**
         * The relatively indexed position where 0 represents the center, negative is left, and positive
         * represents the right.
         */
        _this.position = null;
        /**
         * The initial relatively index origin of the tab if it was created and selected after there
         * was already a selected tab. Provides context of what position the tab should originate from.
         */
        _this.origin = null;
        /**
         * Whether the tab is currently active.
         */
        _this.isActive = false;
        return _this;
    }
    Object.defineProperty(MatTab.prototype, "content", {
        /**
         * @return {?}
         */
        get: function () { return this._contentPortal; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    MatTab.prototype.ngOnChanges = function (changes) {
        if (changes.hasOwnProperty('textLabel')) {
            this._labelChange.next();
        }
        if (changes.hasOwnProperty('disabled')) {
            this._disableChange.next();
        }
    };
    /**
     * @return {?}
     */
    MatTab.prototype.ngOnDestroy = function () {
        this._disableChange.complete();
        this._labelChange.complete();
    };
    /**
     * @return {?}
     */
    MatTab.prototype.ngOnInit = function () {
        this._contentPortal = new TemplatePortal(this._content, this._viewContainerRef);
    };
    MatTab.decorators = [
        { type: Component, args: [{selector: 'mat-tab',
                    template: "<ng-template><ng-content></ng-content></ng-template>",
                    inputs: ['disabled'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    preserveWhitespaces: false,
                    exportAs: 'matTab',
                },] },
    ];
    /**
     * @nocollapse
     */
    MatTab.ctorParameters = function () { return [
        { type: ViewContainerRef, },
    ]; };
    MatTab.propDecorators = {
        'templateLabel': [{ type: ContentChild, args: [MatTabLabel,] },],
        '_content': [{ type: ViewChild, args: [TemplateRef,] },],
        'textLabel': [{ type: Input, args: ['label',] },],
    };
    return MatTab;
}(_MatTabMixinBase));
export { MatTab };
function MatTab_tsickle_Closure_declarations() {
    /** @type {?} */
    MatTab.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatTab.ctorParameters;
    /** @type {?} */
    MatTab.propDecorators;
    /**
     * Content for the tab label given by <ng-template mat-tab-label>.
     * @type {?}
     */
    MatTab.prototype.templateLabel;
    /**
     * Template inside the MatTab view that contains an <ng-content>.
     * @type {?}
     */
    MatTab.prototype._content;
    /**
     * The plain text label for the tab, used when there is no template label.
     * @type {?}
     */
    MatTab.prototype.textLabel;
    /**
     * The portal that will be the hosted content of the tab
     * @type {?}
     */
    MatTab.prototype._contentPortal;
    /**
     * Emits whenever the label changes.
     * @type {?}
     */
    MatTab.prototype._labelChange;
    /**
     * Emits whenevfer the disable changes
     * @type {?}
     */
    MatTab.prototype._disableChange;
    /**
     * The relatively indexed position where 0 represents the center, negative is left, and positive
     * represents the right.
     * @type {?}
     */
    MatTab.prototype.position;
    /**
     * The initial relatively index origin of the tab if it was created and selected after there
     * was already a selected tab. Provides context of what position the tab should originate from.
     * @type {?}
     */
    MatTab.prototype.origin;
    /**
     * Whether the tab is currently active.
     * @type {?}
     */
    MatTab.prototype.isActive;
    /** @type {?} */
    MatTab.prototype._viewContainerRef;
}
//# sourceMappingURL=tab.js.map